import type { DateTime } from "luxon";

const dayEdgeFormat = "yyyy-MM-dd'T'HH:mm";

export const isDayEdgeValue = (value: DateTime | null, edge?: "startOf" | "endOf") => {
	if (value === null) {
		return false;
	}

	const isoValue = value.toFormat(dayEdgeFormat);

	return (
		isoValue === value[edge || "startOf"]("day").toFormat(dayEdgeFormat) ||
		isoValue === value[edge || "endOf"]("day").toFormat(dayEdgeFormat)
	);
};
